<!--Fullscreen Map Starts-->
<section id="fullscreenMap" class="mb-3">
    <div class="row">
        <agm-map [latitude]="lat" [longitude]="lng" style="height: 100%; width: 100%; position: absolute; top: 0px; left: 0px;
        background-color: rgb(229, 227, 223);">
            <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
        </agm-map>
    </div>
</section>
<!--Fullscreen Map Ends-->